import { IAppState } from "src/interface/IAppState";

export const bookmarksSelector = (appState: IAppState) => {
  return appState.bookmarkState
}